import { firebase } from "../firebase/config";
import { finishLoading, startLoading } from "./progress";
import {
  GET_MATERIAL_RECORDS_SUCCESS,
  GET_MATERIAL_RECORDS_REQUEST,
  GET_MATERIAL_RECORDS_FAILURE,
  RECORD_UNARCHIVED_SUCCESS,
  GET_ARCHIVED_RECORDS_SUCCESS,
  RESET_LAST_VISIBLE,
} from "./types";

export const updateMaterialRecord = (recordData, edited, user) => {
  return new Promise((resolve, reject) => {
    let recordUpdate = {}; //obj with only edited fields and values
    for (const i in edited) {
      if (edited[i]) {
        if (i !== "capturedImage") recordUpdate[i] = recordData[i]; //capturedImage (packingSlip) needs processing..
        if (i === "status") {
          if (recordData.status === "AT_SHOP")
            recordUpdate["checkedInAt"] =
              firebase.firestore.FieldValue.serverTimestamp();
          else if (recordData.status === "LEAVING_SHOP")
            recordUpdate["checkedOutAt"] =
              firebase.firestore.FieldValue.serverTimestamp();
        }
      }
    }
    recordUpdate["lastEditedBy"] = user.id;
    recordUpdate["lastEditedAt"] =
      firebase.firestore.FieldValue.serverTimestamp(); //now
    const recordRef = firebase
      .firestore()
      .collection("materialRecords")
      .doc(recordData.id);
    let updatePromise;
    if (edited["capturedImage"] && recordData.capturedImage !== null) {
      const storageRef = firebase.storage().ref();
      const path = "companies/" + user.company + "/poAttachments/";
      updatePromise = uploadFileAndReturnDownloadableUrl(
        //convert image returned via Expo into something digestable by Firebase
        path,
        storageRef,
        recordData.capturedImage
      ).then((fileObj) => {
        recordUpdate["poAttachments"] = [fileObj];
        return;
      });
    } else if (edited["capturedImage"] && recordData.capturedImage === null) {
      //if deleted photo
      recordUpdate["poAttachments"] = [];
      updatePromise = Promise.resolve();
    } else {
      //if no update to packing slip
      updatePromise = Promise.resolve();
    }
    updatePromise
      .then(() => {
        return recordRef.update(recordUpdate).then(() => resolve());
        // resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export const deleteMaterialRecord = (recordId) => {
  firebase
    .firestore()
    .collection("materialRecords")
    .doc(recordId)
    .delete()
    .catch((error) => {});
};

export const addMaterialRecord = (recordData, user) => (dispatch) => {
  const storageRef = firebase.storage().ref();
  const recordRef = firebase.firestore().collection("materialRecords").doc();
  const path = "companies/" + user.company + "/poAttachments/";
  if (recordData.POAttach !== "" && recordData.POAttach !== undefined) {
    uploadFileAndReturnDownloadableUrl(path, storageRef, recordData.POAttach)
      .then((fileObj) => {
        let final;
        if (recordData.Status === "At The Shop") final = "AT_SHOP";
        else if (recordData.Status === "Coming To Shop")
          final = "COMING_TO_SHOP";
        else if (recordData.Status === "Leaving Shop To Site")
          final = "LEAVING_SHOP";
        else final = "COMING_TO_SHOP";
        return recordRef.set({
          id: recordRef.id,
          company: user.company,
          item: recordData.Item,
          type: "COMMODITY",
          checkedInBy: "",
          checkedInAt:
            final === "AT_SHOP"
              ? firebase.firestore.FieldValue.serverTimestamp()
              : null,
          checkedOutBy: "",
          checkedOutAt:
            final === "LEAVING_SHOP"
              ? firebase.firestore.FieldValue.serverTimestamp()
              : null,
          quantity: recordData.Quantity,
          job: recordData.Job === null ? "" : recordData.Job,
          materialOwners: recordData.materialOwners,
          poNumber: recordData.PO,
          vendor: recordData.Vendor === null ? "" : recordData.Vendor,
          status: recordData.Status === null ? "AT_SHOP" : final,
          isBackordered: false,
          isDamaged: false,
          notes: recordData.Notes,
          poAttachments: [fileObj], //filObj when received
          locationInShop: "",
          shipLocation: "SHOP",
          isArchived: false,
          createdBy: user.id,
          createdAt: firebase.firestore.FieldValue.serverTimestamp(), //now
          lastEditedBy: user.id,
          lastEditedAt: firebase.firestore.FieldValue.serverTimestamp(), //now
          // Below are not needed for S/R but for consistency across all materialRecords
          // eta: recordData.eta === null ? null: recordData.eta,
          // needByDate: recordData.needByDate === null ? null: recordData.needByDate,
          eta: recordData.eta === null ? null : recordData.eta,
          needByDate:
            recordData.needByDate === null ? null : recordData.needByDate,
          packingSlipAttachments: [],
        });
      })
      .then(() => {
        // if(recordData.status === 'COMING_TO_SHOP')
        dispatch(getMaterialRecords(user, "COMING_TO_SHOP"));
      })
      .catch((error) => {});
  } else {
    let final;
    if (recordData.Status === "At The Shop") final = "AT_SHOP";
    else if (recordData.Status === "Coming To Shop") final = "COMING_TO_SHOP";
    else if (recordData.Status === "Leaving Shop To Site")
      final = "LEAVING_SHOP";
    else final = "COMING_TO_SHOP";
    return recordRef
      .set({
        id: recordRef.id,
        company: user.company,
        item: recordData.Item,
        type: "COMMODITY",
        checkedInBy: "",
        checkedInAt:
          final === "AT_SHOP"
            ? firebase.firestore.FieldValue.serverTimestamp()
            : null,
        checkedOutBy: "",
        checkedOutAt:
          final === "LEAVING_SHOP"
            ? firebase.firestore.FieldValue.serverTimestamp()
            : null,
        quantity: recordData.Quantity,
        job: recordData.Job === null ? "" : recordData.Job,
        materialOwners: recordData.materialOwners,
        poNumber: recordData.PO,
        vendor: recordData.Vendor === null ? "" : recordData.Vendor,
        status: recordData.Status === null ? "AT_SHOP" : final,
        isBackordered: false,
        isDamaged: false,
        notes: recordData.Notes,
        poAttachments: [], //filObj when received
        locationInShop: "",
        shipLocation: "SHOP",
        isArchived: false,
        createdBy: user.id,
        createdAt: firebase.firestore.FieldValue.serverTimestamp(), //now
        lastEditedBy: user.id,
        lastEditedAt: firebase.firestore.FieldValue.serverTimestamp(), //now
        // Below are not needed for S/R but for consistency across all materialRecords
        // eta: recordData.eta === "" ? null: recordData.eta,
        // needByDate: recordData.needByDate === "" ? null: Date.parse(recordData.needByDate),
        eta: recordData.eta === null ? null : recordData.eta,
        needByDate:
          recordData.needByDate === null ? null : recordData.needByDate,
        packingSlipAttachments: [],
      })
      .then(() => {
        dispatch(getMaterialRecords(user, "COMING_TO_SHOP"));
      });
  }

  // Make sure all dates in Add Entry are set as either null or Date object into Firestore
};

export const addVendor = async (vendor, companyId) => {
  let companyVendors = [];
  const companyDoc = await firebase
    .firestore()
    .collection("companies")
    .doc(companyId)
    .get();
  const companyRef = firebase
    .firestore()
    .collection("companies")
    .doc(companyId);
  const vendorNames = companyDoc.data().vendors;
  let check = vendorNames.filter((x) =>
    x.toLowerCase().includes(vendor.toLowerCase())
  );
  if (check.length === 0) {
    vendorNames.forEach((vendorId) => {
      companyVendors.push(vendorId);
    });
    companyVendors.push(vendor);
    await companyRef.update({ vendors: companyVendors });
    return true;
  }
  return false;
};

export const getCompanyData = async (companyId) => {
  let companyData = {};
  let companyVendors = [];
  let companyJobs = [];
  const companyDoc = await firebase
    .firestore()
    .collection("companies")
    .doc(companyId)
    .get();
  const vendorNames = companyDoc.data().vendors;
  vendorNames.forEach((vendorId) => {
    companyVendors.push({
      //formatting in order for dropdown picker to work
      vendorId,
    });
  });
  companyData["vendors"] = companyVendors;

  const jobQuerySnapshot = await firebase
    .firestore()
    .collection("jobs")
    .where("company", "==", companyId)
    .get();
  let materialOwners = {}; //to avoid unnecessary querying
  let jobDocs = [];
  jobQuerySnapshot.forEach((jobDoc) => {
    //querySnapshot not iterable (only can use forEach)
    jobDocs.push(jobDoc);
  });
  for (const jobDoc of jobDocs) {
    //async/await does not work in forEach
    let procMaterialOwner;
    if (jobDoc.data().materialOwners.length > 0) {
      procMaterialOwner = await processMaterialOwner(jobDoc, materialOwners);
    } else {
      //no need to process materialOwner if none
      procMaterialOwner = { id: "", name: "" };
    }
    companyJobs.push({
      id: jobDoc.data().id,
      name: jobDoc.data().name,
      number: jobDoc.data().number,
      materialOwner: procMaterialOwner,
    });
  }
  companyData["jobs"] = companyJobs;

  return companyData;
};

// Uploading file and getting the downloadable url to be stored in Firestore
export const uploadFileAndReturnDownloadableUrl = (
  storagePath,
  storageRef,
  file
) => {
  return new Promise((resolve, reject) => {
    if (file !== null) {
      // Added newDate().getTime() below b/c >1 file of the same name might be uploaded,
      // and existing file in storage should not be replaced (paths must be unique).
      let fileRef = storageRef.child(
        storagePath + new Date().getTime() + "-" + file.name
      );
      let uploadTask = fileRef.put(file);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log("Error uploading file", error);
          reject(error);
        },
        () => {
          // Handle successful uploads on complete
          uploadTask.snapshot.ref
            .getDownloadURL()
            .then((downloadURL) => {
              console.log("File available at", downloadURL);
              resolve({
                name: file.name,
                url: downloadURL,
              });
            })
            .catch((error) => {
              console.log("Error getting download url", error);
              reject(error);
            });
        }
      );
    } else {
      resolve(null);
    }
  });
};

const getMaterialRecordsSuccess = (records) => {
  return {
    type: GET_MATERIAL_RECORDS_SUCCESS,
    records,
  };
};

const getArchivedRecordsSuccess = (records, lastVisible) => {
  return {
    type: GET_ARCHIVED_RECORDS_SUCCESS,
    records,
    lastVisible,
  };
};

export const resetLastVisible = () => {
  return {
    type: RESET_LAST_VISIBLE,
  };
};

const getMaterialRecordsRequest = () => {
  return {
    type: GET_MATERIAL_RECORDS_REQUEST,
  };
};

const getMaterialRecordsFailure = (error) => {
  return {
    type: GET_MATERIAL_RECORDS_FAILURE,
    error,
  };
};

const recordUnArchived = () => {
  return {
    type: RECORD_UNARCHIVED_SUCCESS,
  };
};

export const getMaterialRecords = (user, status) => (dispatch) => {
  dispatch(getMaterialRecordsRequest());
  let queryPromise;
  if (status !== "BACKORDERED") {
    //coming to shop, at shop, leaving shop
    queryPromise = firebase
      .firestore()
      .collection("materialRecords")
      .where("company", "==", user.company)
      .where("status", "==", status)
      .get();
  } else {
    //backordered
    queryPromise = firebase
      .firestore()
      .collection("materialRecords")
      .where("company", "==", user.company)
      .where("isBackordered", "==", true)
      .get();
  }
  queryPromise
    .then((querySnapshot) => {
      let records = [];
      querySnapshot.forEach((doc) => {
        records.push(doc.data());
      });
      records = orderMaterialRecords(records, status);
      return processMaterialRecords(records);
    })
    .then((procRecords) => {
      dispatch(getMaterialRecordsSuccess(procRecords));
    })
    .catch((error) => {
      dispatch(getMaterialRecordsFailure(error.message));
    });
};

const orderMaterialRecords = (records, status) => {
  if (!records.length) return records;
  records.sort((rowA, rowB) => {
    const direction = -1;
    let sortField;
    if (status === "COMING_TO_SHOP") {
      sortField = "createdAt";
    } else if (status === "LEAVING_SHOP") {
      sortField = "checkedOutAt";
    } else {
      //at shop or backordered
      sortField = "checkedInAt";
    }
    const a = rowA[sortField];
    const b = rowB[sortField];
    let timeA = a ? a.seconds : 0;
    let timeB = b ? b.seconds : 0;
    let compare = timeA - timeB;
    return compare * direction;
  });
  return records;
};

// Needed to use async/await instead of then here b/c promises need to be resolved
// sequentially in for loop for us to avoid repetitive querying
export const processMaterialRecords = async (records) => {
  if (!records.length) return records;
  let procRecords = [];
  // Store companies/users that are queried, so don't need to do unnecessary querying
  let jobs = {};
  let users = {};
  let materialOwners = {};
  let equipmentOrders = {};
  // Handling case where job and user is not inputted
  jobs[""] = {
    id: "",
    number: "",
    name: "",
    materialOwner: { id: "", name: "" },
  };
  users[""] = { id: "", email: "", firstName: "", lastName: "" };
  for (const record of records) {
    let procJob;
    let procCreatedBy;
    let procLastEditedBy;
    let procCheckedInBy;
    const jobId = record.job;
    const createdById = record.createdBy;
    const lastEditedById = record.lastEditedBy;
    const checkedInById = record.checkedInBy;

    // If queried before
    if (jobId in jobs) {
      procJob = jobs[jobId];
    } else {
      // Do new query if not done before and add to tracking map
      const jobDoc = await firebase
        .firestore()
        .collection("jobs")
        .doc(jobId)
        .get();
      let procMaterialOwner;
      if (jobDoc.data().materialOwners.length > 0) {
        procMaterialOwner = await processMaterialOwner(jobDoc, materialOwners);
      } else {
        //no need to process materialOwner if none
        procMaterialOwner = { id: "", name: "" };
      }
      procJob = {
        id: jobId,
        number: jobDoc.data().number,
        name: jobDoc.data().name,
        // Only allowing one material owner right now
        materialOwner: procMaterialOwner,
      };
      jobs[jobId] = procJob;
    }

    // Do the same for createdBy (user)
    if (createdById in users) {
      procCreatedBy = users[createdById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(createdById)
          .get();
        if (userDoc.data()) {
          procCreatedBy = {
            id: createdById,
            email: userDoc.data().email ? userDoc.data().email : "",
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[createdById] = procCreatedBy;
        }
      } catch (error) {}
    }

    // Do the same for lastEditedBy (user)
    if (lastEditedById in users) {
      procLastEditedBy = users[lastEditedById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(lastEditedById)
          .get();
        if (userDoc.data()) {
          procLastEditedBy = {
            id: lastEditedById,
            email: userDoc.data().email,
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[lastEditedById] = procLastEditedBy;
        }
      } catch (error) {}
    }

    // Do the same for checkedInBy (user)
    if (checkedInById in users) {
      procCheckedInBy = users[checkedInById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(checkedInById)
          .get();
        if (userDoc.data()) {
          procCheckedInBy = {
            id: checkedInById,
            email: userDoc.data().email,
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[checkedInById] = procCheckedInBy;
        }
      } catch (error) {
        procCheckedInBy = "";
      }
    }
    let recordPo = {};
    if (record.po in equipmentOrders) {
      recordPo = equipmentOrders[record.po];
    } else {
      if (record.po) {
        const po = await firebase
          .firestore()
          .collection("equipmentOrders")
          .doc(record.po)
          .get();
        if (po) {
          recordPo = po.data();
          equipmentOrders[record.po] = recordPo;
        }
      }
    }

    // Process dates
    const procCreatedAt = convertTimestampToString5(record.createdAt);
    const procLastEditedAt = convertTimestampToString(record.lastEditedAt);
    const procCheckedInAt = convertTimestampToString(record.checkedInAt);
    const procCheckedOutAt = convertTimestampToString(record.checkedOutAt);
    const procETA = convertTimestampToString(record.eta);
    const procNeedByDate = convertTimestampToString2(record.needByDate);
    const plannedReleaseDate = convertTimestampToString2(
      record.plannedReleaseDate
    );
    const releaseDate = convertTimestampToString2(record.releaseDate);
    const shipDate = convertTimestampToString2(record.shipDate);
    const eta = convertTimestampToString2(record.eta);

    // Wait for all record promises to resolve
    procRecords.push({
      ...record,
      checkedInBy: procCheckedInBy,
      checkedInAt: procCheckedInAt,
      checkedOutAt: procCheckedOutAt,
      job: procJob,
      createdBy: procCreatedBy,
      lastEditedBy: procLastEditedBy,
      createdAt: procCreatedAt,
      lastEditedAt: procLastEditedAt,
      eta: record.eta === null ? null : procETA,
      needByDate: record.needByDate === null ? null : procNeedByDate,
      //  procNeedByDate,
      needByFormat:
        record.needByDate === null
          ? null
          : convertTimestampToString2(record.needByDate),
      etaFormat:
        record.eta === null ? null : convertTimestampToString2(record.eta),
      checkedInFormat: convertTimestampToString3(record.checkedInAt),
      checkedOutFormat: convertTimestampToString3(record.checkedOutAt),
      plannedReleaseDate:
        record.plannedReleaseDate === null ? null : plannedReleaseDate,
      releaseDate: record.releaseDate === null ? null : releaseDate,
      shipDate: record.shipDate === null ? null : shipDate,
      po: record.po === null ? null : recordPo,
      eta: record.eta === null ? null : eta,
    });
  }

  // Wait for all promises to resolve
  return procRecords;
};

export const processEquipmentRecords = async (
  records,
  { fetchedVendors ,
  fetchedMaterialOwners ,
  fetchedEquipmentOrders ,
  fetchedJobs,
  fetchedUsers,
 }={}
 
) => {
  if (!records.length) return records;
  let procRecords = [];
  // Store companies/users that are queried, so don't need to do unnecessary querying
  let jobs = fetchedJobs?fetchedJobs:{};
  let users = fetchedUsers?fetchedUsers:{};
  let materialOwners = fetchedMaterialOwners?fetchedMaterialOwners:{};
  let equipmentOrders = fetchedEquipmentOrders?fetchedEquipmentOrders:{};
  let vendors = fetchedVendors?fetchedVendors:{};
  users[""] = { id: "", email: "", firstName: "", lastName: "" };
  for (const record of records) {
    // let procJob;
    let procCreatedBy;
    let procLastEditedBy;
    let procCheckedInBy;
    let procMaterialOwners;
    const jobId = record.job;
    const createdById = record.createdBy;
    const lastEditedById = record.lastEditedBy;
    const checkedInById = record.checkedInBy;

    // Do the same for createdBy (user)
    if (createdById in users) {
      procCreatedBy = users[createdById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(createdById)
          .get();
        if (userDoc.data()) {
          procCreatedBy = {
            id: createdById,
            email: userDoc.data().email ? userDoc.data().email : "",
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[createdById] = procCreatedBy;
        }
      } catch (error) {}
    }

    if (record.materialOwners && record.materialOwners.length > 0) {
      procMaterialOwners = await processAllMaterialOwner(
        record.materialOwners,
        materialOwners
      );
    } else {
      //no need to process materialOwner if none
      procMaterialOwners = [];
    }

    // Do the same for lastEditedBy (user)
    if (lastEditedById in users) {
      procLastEditedBy = users[lastEditedById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(lastEditedById)
          .get();
        if (userDoc.data()) {
          procLastEditedBy = {
            id: lastEditedById,
            email: userDoc.data().email,
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[lastEditedById] = procLastEditedBy;
        }
      } catch (error) {}
    }

    // Do the same for checkedInBy (user)
    if (checkedInById in users) {
      procCheckedInBy = users[checkedInById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(checkedInById)
          .get();
        if (userDoc.data()) {
          procCheckedInBy = {
            id: checkedInById,
            email: userDoc.data().email,
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[checkedInById] = procCheckedInBy;
        }
      } catch (error) {
        procCheckedInBy = "";
      }
    }
    let recordPo = {};
    if (record.po in equipmentOrders) {
      recordPo = equipmentOrders[record.po];
    } else {
      try {
        if (record.po) {
          const po = await firebase
            .firestore()
            .collection("equipmentOrders")
            .doc(record.po)
            .get();
          if (po) {
            recordPo = po.data();
            equipmentOrders[record.po] = recordPo;
          }
        }
      } catch (error) {}
    }
    let vendorDetails = {};
    let allVendorContacts = {};
    let recordContacts = [];
    if (record.vendorId in vendors) {
      vendorDetails = vendors[record.vendorId];

      if (record.vendorContacts) {
        recordContacts = record.vendorContacts.map((recordContact) => {
          const checkContact = vendors[record.vendorId].contacts.filter(
            (contact) => contact.id === recordContact
          );
          return { ...checkContact[0] };
        });
      }
      // recordContacts = checkContact.length > 0 ? checkContact[0] : null;
    } else {
      try {
        if (record.vendorId) {
          const vendorData = await firebase
            .firestore()
            .collection("vendors")
            .doc(record.vendorId)
            .get();

          if (vendorData) {
            const vend = vendorData.data();
            const contacts = await processAllVendorContacts(
              vend.vendorContacts,
              allVendorContacts
            );

            // recordContact = checkContact.length > 0 ? checkContact[0] : null;
            if (record.vendorContacts) {
              recordContacts = record.vendorContacts.map((recordContact) => {
                const checkContact = contacts.filter(
                  (contact) => contact.id === recordContact
                );
                return { ...checkContact[0] };
              });
            }

            vendorDetails = {
              ...vend,
              contacts,
            };
            vendors[record.vendorId] = {
              ...vendorDetails,
              vendorContacts: contacts,
            };
          }
        }
      } catch (error) {}
    }

    // Process dates
    const procCreatedAt = convertTimestampToString5(record.createdAt);
    const procLastEditedAt = convertTimestampToString(record.lastEditedAt);
    const procCheckedInAt = convertTimestampToString4(record.checkedInAt);
    const procCheckedOutAt = convertTimestampToString4(record.checkedOutAt);
    const procDeliveredAt = convertTimestampToString4(record.deliveredAt);
    const procETA = convertTimestampToString2(record.eta);
    const procNeedByDate = convertTimestampToString2(record.needByDate);
    const plannedReleaseDate = convertTimestampToString2(
      record.plannedReleaseDate
    );
    const releaseDate = convertTimestampToString2(record.releaseDate);
    const shipDate = convertTimestampToString2(record.shipDate);

    // Wait for all record promises to resolve
    procRecords.push({
      ...record,
      vendorDetails,
      vendorContacts: recordContacts,
      materialOwners: procMaterialOwners,
      checkedInBy: procCheckedInBy,
      checkedInAt: procCheckedInAt,
      checkedOutAt: procCheckedOutAt,
      deliveredAt: procDeliveredAt,
      createdBy: procCreatedBy,
      lastEditedBy: procLastEditedBy,
      createdAt: procCreatedAt,
      lastEditedAt: procLastEditedAt,
      eta: record.eta === null ? null : procETA,
      needByDate: record.needByDate === null ? null : procNeedByDate,
      //  procNeedByDate,
      needByFormat:
        record.needByDate === null
          ? null
          : convertTimestampToString2(record.needByDate),
      etaFormat:
        record.eta === null ? null : convertTimestampToString2(record.eta),
      checkedInFormat: convertTimestampToString3(record.checkedInAt),
      checkedOutFormat: convertTimestampToString3(record.checkedOutAt),
      plannedReleaseDate:
        record.plannedReleaseDate === null ? null : plannedReleaseDate,
      releaseDate: record.releaseDate === null ? null : releaseDate,
      shipDate: record.shipDate === null ? null : shipDate,
      po: record.po === null ? null : recordPo,
    });
  }

  // Wait for all promises to resolve
  return procRecords;
};

export const processReturnedEquipmentRecords = async (records) => {
  if (!records.length) return records;
  let procRecords = [];
  // Store companies/users that are queried, so don't need to do unnecessary querying
  let jobs = {};
  let users = {};
  let materialOwners = {};
  let equipmentOrders = {};
  let vendors = {};
  // jobs[""] = {
  //   id: "",
  //   number: "",
  //   name: "",
  //   materialOwner: { id: "", name: "" },
  // };
  // let jobsFrom={}

  users[""] = { id: "", email: "", firstName: "", lastName: "" };
  for (const record of records) {
    let procJob;
    let procJobFrom;
    let procCreatedBy;
    let procLastEditedBy;
    let procCheckedInBy;
    const jobId = record.job;
    const jobFromId = record.jobFrom;
    const createdById = record.createdBy;
    const lastEditedById = record.lastEditedBy;
    const checkedInById = record.checkedInBy;
    let materialOwnersFrom = [];

    if (jobFromId in jobs) {
      procJobFrom = jobs[jobFromId];
    } else {
      // Do new query if not done before and add to tracking map
      if (jobFromId) {
        const jobDoc = await firebase
          .firestore()
          .collection("jobs")
          .doc(jobFromId)
          .get();
        let procMaterialOwner;
        if (jobDoc.data().materialOwners.length > 0) {
          procMaterialOwner = await processMaterialOwner(
            jobDoc,
            materialOwners
          );
        } else {
          //no need to process materialOwner if none
          procMaterialOwner = { id: "", name: "" };
        }
        procJobFrom = {
          id: jobFromId,
          number: jobDoc.data().number,
          name: jobDoc.data().name,
          // Only allowing one material owner right now
          materialOwner: procMaterialOwner,
        };
        jobs[jobFromId] = procJobFrom;
      }
    }

    if (jobId in jobs) {
      procJob = jobs[jobId];
    } else {
      if (jobId) {
        const jobDoc = await firebase
          .firestore()
          .collection("jobs")
          .doc(jobId)
          .get();
        let procMaterialOwner;
        if (jobDoc.data().materialOwners.length > 0) {
          procMaterialOwner = await processMaterialOwner(
            jobDoc,
            materialOwners
          );
        } else {
          procMaterialOwner = { id: "", name: "" };
        }
        procJob = {
          id: jobId,
          number: jobDoc.data().number,
          name: jobDoc.data().name,
          materialOwner: procMaterialOwner,
        };
        jobs[jobId] = procJob;
      }
    }

    if (record.materialOwnersFrom && record.materialOwnersFrom.length > 0) {
      materialOwnersFrom = [];
      materialOwnersFrom = await processAllMaterialOwner(
        record.materialOwnersFrom,
        materialOwners
      );
      // materialOwnersFrom = await new Promise(async(res, rej)=>{
      //   const materialOwnerRefPromises = [];
      //   record.materialOwnersFrom.forEach(materialOwnerId=>{
      //     const materialOwnerRef=  firebase
      //   .firestore()
      //   .collection("materialOwners")
      //   .doc(materialOwnerId)
      //   .get();
      //   materialOwnerRefPromises.push(materialOwnerRef);
      //   });
      //   Promise.all(materialOwnerRefPromises).then(owners=>{
      //     const allOwners = [];
      //     owners.forEach(owner=>{
      //       allOwners.push(owner.data())
      //     })
      //     res(allOwners)
      //   })

      // });
    } else {
      //no need to process materialOwner if none
      materialOwnersFrom = [];
    }

    // Do the same for createdBy (user)
    if (createdById in users) {
      procCreatedBy = users[createdById];
    } else {
      const userDoc = await firebase
        .firestore()
        .collection("users")
        .doc(createdById)
        .get();
      if (userDoc.data()) {
        procCreatedBy = {
          id: createdById,
          email: userDoc.data().email ? userDoc.data().email : "",
          firstName: userDoc.data().firstName,
          lastName: userDoc.data().lastName,
        };
        users[createdById] = procCreatedBy;
      }
    }

    // Do the same for lastEditedBy (user)
    if (lastEditedById in users) {
      procLastEditedBy = users[lastEditedById];
    } else {
      const userDoc = await firebase
        .firestore()
        .collection("users")
        .doc(lastEditedById)
        .get();
      if (userDoc.data()) {
        procLastEditedBy = {
          id: lastEditedById,
          email: userDoc.data().email,
          firstName: userDoc.data().firstName,
          lastName: userDoc.data().lastName,
        };
        users[lastEditedById] = procLastEditedBy;
      }
    }

    // Do the same for checkedInBy (user)
    if (checkedInById in users) {
      procCheckedInBy = users[checkedInById];
    } else {
      try {
        const userDoc = await firebase
          .firestore()
          .collection("users")
          .doc(checkedInById)
          .get();
        if (userDoc.data()) {
          procCheckedInBy = {
            id: checkedInById,
            email: userDoc.data().email,
            firstName: userDoc.data().firstName,
            lastName: userDoc.data().lastName,
          };
          users[checkedInById] = procCheckedInBy;
        }
      } catch (error) {
        procCheckedInBy = "";
      }
    }

    let recordPo = {};
    if (record.po in equipmentOrders) {
      recordPo = equipmentOrders[record.po];
    } else {
      if (record.po) {
        try {
          const po = await firebase
            .firestore()
            .collection("equipmentOrders")
            .doc(record.po)
            .get();
          if (po) {
            recordPo = po.data();
            equipmentOrders[record.po] = recordPo;
          }
        } catch (error) {}
      }
    }

    let vendorDetails = {};
    if (record.vendorId in vendors) {
      vendorDetails = vendors[record.vendorId];
    } else {
      try {
        if (record.vendorId) {
          const vendorData = await firebase
            .firestore()
            .collection("vendors")
            .doc(record.vendorId)
            .get();
          if (vendorData) {
            vendorDetails = vendorData.data();
            vendors[record.vendorId] = vendorDetails;
          }
        }
      } catch (error) {}
    }

    // Process dates
    const procCreatedAt = convertTimestampToString5(record.createdAt);
    const procLastEditedAt = convertTimestampToString(record.lastEditedAt);
    const procCheckedInAt = convertTimestampToString5(record.checkedInAt);
    const procCheckedOutAt = convertTimestampToString4(record.checkedOutAt);
    const procDeliveredAt = convertTimestampToString4(record.deliveredAt);
    const procETA = convertTimestampToString2(record.eta);
    const procNeedByDate = convertTimestampToString2(record.needByDate);
    const plannedReleaseDate = convertTimestampToString2(
      record.plannedReleaseDate
    );
    const releaseDate = convertTimestampToString2(record.releaseDate);
    const shipDate = convertTimestampToString2(record.shipDate);

    // Wait for all record promises to resolve
    procRecords.push({
      ...record,
      vendorDetails,
      materialOwnersFrom,
      jobFrom: procJobFrom,
      job: procJob,
      checkedInBy: procCheckedInBy,
      checkedInAt: procCheckedInAt,
      checkedOutAt: procCheckedOutAt,
      deliveredAt: procDeliveredAt,
      createdBy: procCreatedBy,
      lastEditedBy: procLastEditedBy,
      createdAt: procCreatedAt,
      lastEditedAt: procLastEditedAt,
      eta: record.eta === null ? null : procETA,
      needByDate: record.needByDate === null ? null : procNeedByDate,
      //  procNeedByDate,
      needByFormat:
        record.needByDate === null
          ? null
          : convertTimestampToString2(record.needByDate),
      etaFormat:
        record.eta === null ? null : convertTimestampToString2(record.eta),
      checkedInFormat: convertTimestampToString3(record.checkedInAt),
      checkedOutFormat: convertTimestampToString3(record.checkedOutAt),
      plannedReleaseDate:
        record.plannedReleaseDate === null ? null : plannedReleaseDate,
      releaseDate: record.releaseDate === null ? null : releaseDate,
      shipDate: record.shipDate === null ? null : shipDate,
      po: record.po === null ? null : recordPo,
    });
  }

  // Wait for all promises to resolve
  return procRecords;
};

const convertTimestampToString = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    // const ye = new Intl.DateTimeFormat('en', { year: '2-digit' }).format(date);
    const mon = new Intl.DateTimeFormat("en", { month: "short" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    const dateString = `${mon} ${da}`;
    return dateString;
  } catch (error) {
    return "";
  }
};

export const convertTimestampToString2 = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mon = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    if (mon < 10) mon = "0" + mon;

    const dateString = `${mon}/${da}/${ye}`;
    return dateString;
  } catch (error) {
    return "";
  }
};

export const convertTimestampToString3 = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mon = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    // if (mon < 10) mon = "0" + mon;
    // if (da < 10) da = "0" + da;

    const dateString = `${mon}/${da}/${ye}`;
    return dateString;
  } catch (error) {
    return "";
  }
};
export const convertTimestampToString4 = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    const mon = new Intl.DateTimeFormat("en", { month: "short" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    const time = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      minute: "2-digit",
      // second: '2-digit',
      // hour12: true
    }).format(date);
    const dateString = `${mon} ${da} - ${time}`;
    // if (mon < 10) mon = "0" + mon;
    // if (da < 10) da = "0" + da;

    // const dateString = `${mon}/${da}/${ye}`;
    return dateString;
  } catch (error) {
    return "";
  }
};
export const convertTimestampToString5 = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    return date.toString();
  } catch (error) {
    return "";
  }
};

export const convertTimestampToString6 = (timestamp) => {
  if (timestamp === null) {
    return "";
  }
  try {
    const date = new Date(timestamp.seconds * 1000);
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mon = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    const time = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      minute: "2-digit",
      // second: '2-digit',
      // hour12: true
    }).format(date);
    // if (mon < 10) mon = "0" + mon;
    // if (da < 10) da = "0" + da;

    const dateString = `${mon}/${da}/${ye} - ${time}`;
    return dateString;
  } catch (error) {
    return "";
  }
};

export const convertTimestampToString7 = (date) => {
  try {
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mon = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    // if (mon < 10) mon = "0" + mon;
    // if (da < 10) da = "0" + da;

    const dateString = `${mon}/${da}/${ye}`;
    return dateString;
  } catch (error) {
    return "";
  }
};

export const convertTimestampToString8 = (date2) => {
  try {
    const date = new Date(date2);
    const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    let mon = new Intl.DateTimeFormat("en", { month: "numeric" }).format(date);
    const da = new Intl.DateTimeFormat("en", { day: "numeric" }).format(date);
    const time = new Intl.DateTimeFormat("en", {
      hour: "2-digit",
      minute: "2-digit",
      // second: '2-digit',
      // hour12: true
    }).format(date);
    // if (mon < 10) mon = "0" + mon;
    // if (da < 10) da = "0" + da;

    const dateString = `${mon}/${da}/${ye} - ${time}`;
    return dateString;
  } catch (error) {
    return "";
  }
};

const processMaterialOwner = async (jobDoc, materialOwners) => {
  //materialOwners is passed by reference
  let procMaterialOwner;
  const materialOwnerId = jobDoc.data().materialOwners[0]; //just one material owner for now
  if (materialOwnerId in materialOwners) {
    procMaterialOwner = materialOwners[materialOwnerId];
  } else {
    const materialOwnerDoc = await firebase
      .firestore()
      .collection("materialOwners")
      .doc(materialOwnerId)
      .get();
    const owner = materialOwnerDoc.data();
    procMaterialOwner = {
      ...owner,
    };
    materialOwners[materialOwnerId] = procMaterialOwner;
  }
  return procMaterialOwner;
};
const processAllMaterialOwner = (materialOwnersIds, materialOwners) => {
  return new Promise(async (res, rej) => {
    const materialOwnerRefPromises = [];
    const allOwners = [];
    for (const materialOwnerId of materialOwnersIds) {
      const check =
        materialOwners[
          materialOwnerId.id ? materialOwnerId.id : materialOwnerId
        ];
      if (check) {
        allOwners.push(
          materialOwners[
            materialOwnerId.id ? materialOwnerId.id : materialOwnerId
          ]
        );
      } else {
        try {
          const materialOwnerRef = await firebase
            .firestore()
            .collection("materialOwners")
            .doc(materialOwnerId.id ? materialOwnerId.id : materialOwnerId)
            .get()
            .catch();
          if (materialOwnerRef) {
            materialOwnerRefPromises.push(materialOwnerRef);
          }
        } catch (error) {}
      }
    }

    materialOwnerRefPromises.forEach((owner) => {
      const details = owner.data();
      materialOwners[owner.id] = { ...details };
      allOwners.push({ ...details });
    });
    res(allOwners);
  });
};
export const processAllVendorContacts = (vendrsIds, vendors) => {
  return new Promise(async (res, rej) => {
    const vendorContactsRefPromises = [];
    const allVendors = [];
    vendrsIds.forEach((vendorId) => {
      const check = vendrsIds[vendorId.id ? vendorId.id : vendorId];
      if (check) {
        allVendors.push(vendors[vendorId.id ? vendorId.id : vendorId]);
      } else {
        const vendorsContactRef = firebase
          .firestore()
          .collection("vendorContacts")
          .doc(vendorId.id ? vendorId.id : vendorId)
          .get();
        vendorContactsRefPromises.push(vendorsContactRef);
      }
    });
    Promise.all(vendorContactsRefPromises).then((vendors) => {
      vendors.forEach((vendor) => {
        const details = vendor.data();
        vendors[allVendors.id] = { ...details };
        allVendors.push({ ...details });
      });
      res(allVendors);
    });
  });
};

export const unArchiveRecord = (recordId, userId) => (dispatch) => {
  dispatch(startLoading());
  const serverTime = firebase.firestore.FieldValue.serverTimestamp();
  return firebase
    .firestore()
    .collection("materialRecords")
    .doc(recordId)
    .update({
      isArchived: false,
    })
    .then((reference) => {
      dispatch(recordUnArchived());
      dispatch(finishLoading());
      dispatch(resetLastVisible());
    });
};

export const fetchArchivedRecords =
  (user, lastVisible, prevRecords) => (dispatch) => {
    dispatch(startLoading());
    return new Promise((resolve, reject) => {
      let queryPromise;
      if (lastVisible == null) {
        queryPromise = firebase
          .firestore()
          .collection("materialRecords")
          .where("company", "==", user.company)
          .where("isArchived", "==", true)
          .orderBy("checkedOutAt", "desc")
          .limit(10)
          .get();
      } else {
        queryPromise = firebase
          .firestore()
          .collection("materialRecords")
          .where("company", "==", user.company)
          .where("isArchived", "==", true)
          .orderBy("checkedOutAt", "desc")
          .startAfter(lastVisible)
          .limit(8)
          .get();
      }
      dispatch(startLoading());

      queryPromise
        .then((querySnapshot) => {
          let records = [];
          querySnapshot.forEach((doc) => {
            records.push(doc.data());
          });
          lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
          return processMaterialRecords(records);
        })
        .then((pp) => {
          const records = [...prevRecords, ...pp];
          dispatch(getArchivedRecordsSuccess(records, lastVisible));
          dispatch(finishLoading());
          // resolve(lastVisible);
        });
    });
  };

export const convertUTCDateToLocalDate = (dateString) => {
  const date = new Date(dateString);
  var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

  var offset = date.getTimezoneOffset() / 60;
  var hours = date.getHours();

  newDate.setHours(hours - offset);

  return newDate;
};
